module.exports = __webpack_public_path__ + "static/media/9DESA13.452e858a.jpg";